import { render, staticRenderFns } from "./BasePrompt.vue?vue&type=template&id=b4b3e5e8"
import script from "./BasePrompt.vue?vue&type=script&lang=js"
export * from "./BasePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports